import React, { useState } from 'react';
import InvoicePayment from '../RSheets/CommonCustomElements/InvoicePayment';

function InvoiceEditor(props) {
    // Required 
    // data 
    // entryData 
    const [input, setInput] = useState('');
    const [the_invoices, set_the_invoices] = useState([]);

    const updateDataObj = () => {

    }

    const saveRS = () => {

    }

    const sheetType = props.entryData?.type;
    const title = props.data.illi_number;
    const project_name = props.data.project_name;
    
    console.log('InvoiceEditor', props);

    return (
        <div className="invoice-editor">
        <h3>Invoice Editor RS#{props.entryData?.id} (illi #{title}) {project_name ? `(${project_name})` : null}</h3>
        <InvoicePayment
            commissionValue={null}
            setInput={setInput}
            input={input}
            updateDataObj={updateDataObj}
            data={props.data}
            field={null}
            canEditInvoiceRelatedData={true}
            saveRS={saveRS}
            sheetType={sheetType}
            the_invoices={the_invoices}
            set_the_invoices={set_the_invoices}
            id={props.entryData.id}
        />
        </div>
    );
}

export default InvoiceEditor;
